import React from 'react';

const Divider = ({ style }) => (
  <div style={{ height: 1, background: 'var(--line-soft)', ...style }} />
);

export default Divider;
